import type { ServiceCardSmallProps } from "@/components/screen/global-components/services/ServiceCardSmall";

const servicesTrustedExpertiseContentStandard = {
  title: "Experienced partner across a variety of deliverables",
  description:
    "We offer content translation experience across a range of documents and digital formats",
} as const;

const servicesTrustedExpertiseCardsStandard: ServiceCardSmallProps[] = [
  {
    title: "Financial Report",
    description:
      "Deliver precise financial translations maintaining technical terminology and regulatory compliance.",
    link: "/documents/financial-report",
    linkLabel: "Review",
  },
  {
    title: "Contract",
    description:
      "Provide accurate translations of contractual documents that preserve original intent and legal nuance.",
    link: "/documents/contract",
    linkLabel: "Review",
  },
  {
    title: "Patent",
    description:
      "Translate complex patent documentation with technical expertise and linguistic precision.",
    link: "/documents/patent",
    linkLabel: "Review",
  },
  {
    title: "Book",
    description:
      "Capture essence and cultural subtleties through professional literary translation services.",
    link: "/documents/book",
    linkLabel: "Review",
  },
  {
    title: "Product Manual",
    description:
      "Translate technical documentation, instructions, and descriptions with precision to ensure clear understanding worldwide.",
    link: "/documents/manual",
    linkLabel: "Review",
  },
  {
    title: "Website",
    description:
      "Localize multilingual websites that engage global audiences and enhance international digital presence.",
    link: "/documents/website",
    linkLabel: "Review",
  },
  {
    title: "Video",
    description:
      "Translate video and multimedia content with subtitling that preserves original intent and cultural nuance.",
    link: "/documents/video",
    linkLabel: "Review",
  },
  {
    title: "Software",
    description:
      "Enable seamless global software localization, adapting user interfaces, help content, and technical documentation for international markets.",
    link: "/documents/software",
    linkLabel: "Review",
  },
  {
    title: "E-learning",
    description:
      "Transform educational content into accessible, culturally-relevant learning experiences across language boundaries.",
    link: "/documents/e-learning",
    linkLabel: "Review",
  },
  {
    title: "Explore all types",
    link: "/documents",
    isStatic: true,
  },
];

export const servicesTrustedExpertisePropsMap = {
  standard: {
    content: servicesTrustedExpertiseContentStandard,
    cards: servicesTrustedExpertiseCardsStandard,
  },
};
